import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {InvoiceStatusType} from "../../types/invoice-status.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class BillingOrdersTableCtrl implements IController {
  isBillingAccountView: boolean;
  enableActions: boolean;
  hideConsolidatedColumn: boolean;
  ids: string[];
  consolidatedIds: string[];
  selectedOrder: any;
  selectedOrders: any;
  excludeMode: boolean;
  columns?: any;
  queryString: string;
  ignoreConsolidated: boolean;
  from: number;
  to: number;
  accountId: any;
  packagesIds: any;
  billingAccountId: any;
  status: any;
  tagNames: any;
  invoiceStatuses: InvoiceStatusType[];
  canSelect: boolean;
  filterByOrderCompletedDate: boolean;
  hasPrice: boolean;
  isShowEdiStatusCol: any;
  isConsolidated: boolean;
  sortFieldType: string;
  sortFieldName: string;
  doReload: string;
  onSelectChange: Function;
  onOrderClick: Function;
  onEdit: Function;
  onEditOrder: Function;
  onConsolidate: Function;
  onRemoveConsolidate: Function;
  onFilterByType: Function;
  onSortChange: Function;
  onReload: Function;

  public billingOrdersRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public selectedKeys: any;
  public asceDescIconsMap: any;

  constructor(private $infiniteScroll, private $billingOrders, private moment, private $log,
              private commonsAlertsService: CommonsAlertsService, private $mdMedia, private commonsConstants) {
    this.asceDescIconsMap = commonsConstants.sortIconsMap;
  }

  $onInit() {
    this.billingOrdersRef = this.$billingOrders();
    this.billingOrdersRef.$query(this._getBillingOrdersQuery());
    this.infiniteScroll = this.$infiniteScroll(this.billingOrdersRef, this.loadLimit, {getFullData: true});
    this.selectedKeys = {};
  };

  $onChanges(changes) {

    if (changes.selectedOrders || changes.excludeMode) {
      this.selectedKeys = {};
      _.forEach(this.selectedOrders, (o) => {
        this.selectedKeys[o.id] = true;
      });

    }

    if (
      (changes.queryString && !changes.queryString.isFirstChange()) ||
      (changes.ids && !changes.ids.isFirstChange()) ||
      (changes.consolidatedIds && !changes.consolidatedIds.isFirstChange()) ||
      (changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange()) ||
      (changes.accountId && !changes.accountId.isFirstChange()) ||
      (changes.packagesIds && !changes.packagesIds.isFirstChange()) ||
      (changes.billingAccountId && !changes.billingAccountId.isFirstChange()) ||
      (changes.status && !changes.status.isFirstChange()) ||
      (changes.tagNames && !changes.tagNames.isFirstChange()) ||
      (changes.hasPrice && !changes.hasPrice.isFirstChange()) ||
      (changes.invoiceStatuses && !changes.invoiceStatuses.isFirstChange() ||
        (changes.filterByOrderCompletedDate && !changes.filterByOrderCompletedDate.isFirstChange()) ||
        (changes.sortFieldName && !changes.sortFieldName.isFirstChange()) ||
        (changes.sortFieldType && !changes.sortFieldType.isFirstChange()) ||
        (changes.doReload && !changes.doReload.isFirstChange()) ||
        (changes.isConsolidated && !changes.isConsolidated.isFirstChange()))
    ) {
      this._loadBillingOrders();
    }
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  _loadBillingOrders() {
    this.billingOrdersRef.$query(this._getBillingOrdersQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
      .finally(() => {
        this.onReload();
      })
  }

  $doCheck() {
    const numOfColumns = _.reduce(this.columns, (sum, column) => {
      return sum += column.enabled ? 1 : 0;
    }, 0);

    this.isScrollable = numOfColumns > 11 || _.isUndefined(this.columns) ? true : !this.$mdMedia('gt-md');
  };

  // onSelectionToggle(billingOrder) {
  //   if (!_.get(billingOrder, 'id')) {
  //     return;
  //   }
  //
  //   const selectedOrders = _.includes(_.map(this.selectedOrders, 'id'), billingOrder.id) ?
  //     _.filter(this.selectedOrders, (order) => {
  //       return order.id !== billingOrder.id;
  //     }) : _.concat(this.selectedOrders, [billingOrder]);
  //
  //   this.onChangeSelectedOrders({billingOrders: selectedOrders});
  // }

  onToggleSelectAll() {
    this.onSelectChange({selectedOrders: [], excludeMode: !this.excludeMode});
  }

  onToggleSelected(billingOrder) {
    this.selectedKeys[billingOrder.id] = !this.selectedKeys[billingOrder.id];
    const selectedOrders = _.includes(_.map(this.selectedOrders, 'id'), billingOrder.id) ?
      _.filter(this.selectedOrders, (order) => {
        return order.id !== billingOrder.id;
      }) :
      _.concat(this.selectedOrders, [billingOrder]);

    this.onSelectChange({selectedOrders: selectedOrders, excludeMode: this.excludeMode});
  }

  _getBillingOrdersQuery() {
    return {
      limit: this.loadLimit,
      ids: this.ids,
      consolidatedIds: this.consolidatedIds,
      query: this.queryString,
      from: this.from,
      to: this.to,
      accountId: this.accountId,
      itemTypes: this.packagesIds,
      billingAccountId: this.billingAccountId,
      ignoreConsolidated: this.ignoreConsolidated,
      status: this.status,
      omsTags: this.tagNames,
      invoiceStatus: this.invoiceStatuses,
      filterByOrderCompletedDate: this.filterByOrderCompletedDate,
      hasPrice: this.consolidatedIds?.length ? undefined : this.hasPrice,
      sort: (this.sortFieldName && this.sortFieldType) ? `${this.sortFieldName},${this.sortFieldType}` : undefined,
      isConsolidated: this.isConsolidated
    }
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrdersTable', {
    bindings: {
      isBillingAccountView: '<?',
      enableActions: '<?',
      hideConsolidatedColumn: '<?',
      ids: '<?',
      consolidatedIds: '<?',
      selectedOrder: '<?', // For active card style
      selectedOrders: '<?', // For selection
      excludeMode: '<?',
      columns: '<?',
      queryString: '<?',
      ignoreConsolidated: '<?',
      from: '<?',
      to: '<?',
      accountId: '<?',
      packagesIds: '<?',
      billingAccountId: '<?',
      status: '<?',
      tagNames: '<?',
      invoiceStatuses: '<?',
      canSelect: '<?',
      canMultiSelect: '<?',
      filterByOrderCompletedDate: '<?',
      hasPrice: '<',
      isShowEdiStatusCol: '<?',
      isConsolidated: '<',
      sortFieldName: '<?',
      sortFieldType: '<?',
      doReload: '<?',
      onSelectChange: '&',
      onOrderClick: '&',
      onEdit: '&',
      onEditOrder: '&',
      onConsolidate: '&',
      onRemoveConsolidate: '&',
      onFilterByType: '&',
      onSortChange: '&',
      onReload: '&'
    },
    template: require('./billing-orders-table.html').default,
    controller: BillingOrdersTableCtrl
  });
